import LongText from '../Elements/LongText';
import React from 'react';

export default class TpEvaluatorTpJobPaymentClientInvoiceItem {
  constructor(item) {
    if (item === undefined) {
      this.EvaluatorName = '';
      this.ThirdPartyJobId = '';
      this.ClientName = '';
      this.ProjectName = '';
      this.ProjectId = '';
      this.TypeText = '';
      this.Status = '';
      this.Fee = '';
      this.FeeAdjustment = '';
      this.TotalReimb = '';
      this.Vat = '';
      this.JobDate = '';
      this.CreatedOnUtc = '';
      this.ThirdPartyLocationName = '';
      this.ThirdPartyLocationCountry = '';
      this.CurrencyCode = '';
      return;
    }
    this.EvaluatorName =
      (item.tpEvaluatorFirstName ? item.tpEvaluatorFirstName : '') +
      ', ' +
      (item.tpEvaluatorLastName ? item.tpEvaluatorLastName : '');
    this.ThirdPartyJobId = item.thirdPartyJobId;
    this.ClientName = item.clientName;
    this.ProjectName = item.projectName;
    this.ProjectId = item.projectId;
    this.TypeText = item.typeText;
    this.Status = item.status;
    this.Fee = item.fee;
    this.FeeAdjustment = item.feeAdjustment;
    this.TotalReimb = item.totalReimb;
    this.Vat = item.vat;
    this.JobDate = item.jobDate;
    this.CreatedOnUtc = item.createdOnUtc;
    this.ThirdPartyLocationName = item.thirdPartyLocationName;
    this.ThirdPartyLocationCountry = item.thirdPartyLocationCountry;
    this.CurrencyCode = item.currencyCode;
  }

  static MoneyFields = ['Fee', 'FeeAdjustment', 'TotalReimb', 'Vat'];
  static DateFields = ['JobDate', 'CreatedOnUtc'];

  static Currency() {
    return 'CurrencyCode';
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Evaluator', orderById: 'EvaluatorName', data: 'EvaluatorName', minWidth: 40 },
      { label: 'Third-Party Job ID', orderById: 'ThirdPartyJobId', data: 'ThirdPartyJobId', minWidth: 20 },
      {
        label: 'Client',
        orderById: 'ClientName',
        data: TpEvaluatorTpJobPaymentClientInvoiceItem.getClientCellContent,
        minWidth: 40,
      },
      { label: 'Project', orderById: 'ProjectName', data: 'ProjectName', minWidth: 40 },
      { label: 'Project ID', orderById: 'ProjectId', data: 'ProjectId', minWidth: 20 },
      { label: 'Type', orderById: 'TypeText', data: 'TypeText', minWidth: 30 },
      { label: 'Status', orderById: 'Status', data: 'Status', minWidth: 20 },
      { label: 'Fee', orderById: 'Fee', data: 'Fee', minWidth: 20 },
      { label: 'Fee Addit.', orderById: 'FeeAdjustment', data: 'FeeAdjustment', minWidth: 20 },
      { label: 'Expense', orderById: 'Expense', data: 'TotalReimb', minWidth: 20 },
      { label: 'Tax', orderById: 'Vat', data: 'Vat', minWidth: 20 },
      { label: 'Completed On', orderById: 'JobDate', data: 'JobDate', minWidth: 40 },
      { label: 'Created On', orderById: 'CreatedOnUtc', data: 'CreatedOnUtc', minWidth: 40 },
      {
        label: 'Location',
        orderById: 'ThirdPartyLocationName',
        data: TpEvaluatorTpJobPaymentClientInvoiceItem.getLocationCellContent,
        minWidth: 40,
      },
      { label: 'Country', orderById: 'ThirdPartyLocationCountry', data: 'ThirdPartyLocationCountry', minWidth: 10 },
    ];
  }

  static getClientCellContent(item) {
    return (
      <LongText
        text={item.ClientName ? item.ClientName : ' '}
        maxLength={30}
      />
    );
  }

  static getLocationCellContent(item) {
    return (
      <LongText
        text={item.ThirdPartyLocationName ? item.ThirdPartyLocationName : ' '}
        maxLength={30}
      />
    );
  }
}
